/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
require('../vendor/validate.js');

export function contactForm() {

  $('input').on('focus', function () {
    $(this)
      .closest('.gfield')
      .addClass('focused');
  });

  $('input').on('blur', function () {
    if ($(this).val() === '') {
      $(this)
        .closest('.gfield')
        .removeClass('focused');
    }
  });

  $('textarea').on('focus', function () {
    $(this)
      .closest('.gfield')
      .addClass('focused');
  });

  $('textarea').on('blur', function () {
    if ($(this).val() === '') {
      $(this)
        .closest('.gfield')
        .removeClass('focused');
    }
  });

  // Validation
  var contactForm = $('.contactForm__form');
  contactForm.validate({
    submitHandler: function (contactForm) {
      $('.loading').fadeIn();
      contactForm.submit();
      // grecaptcha.reset();
      // grecaptcha.execute();
    },
    rules: {
      "name": 'required',
      "comment": 'required',
      "email": {
        required: true,
        email: true
      }
    },
    messages: {
      "name": "Please, enter your name.",
      "comment": "Please, let us know how we can help.",
      "email": "Please, enter a valid email address."
    }
  });
}
